import PrepressExtraCopiesSortTable from "../react/PrepressExtraCopiesSortTable";
import N2StylesModal from '../components/N2StylesModal';

export default class ExtraCopies {
  constructor(params) {
    this.params = params;
    this.role = params.role || null;
  }

  index() {
    const list = new PrepressExtraCopiesSortTable({
      sortScope: "#sort-filters-prepress-users",
      data: $(".js-prepress-extra-copies-table").data("orders"),
      statuses: $(".js-prepress-extra-copies-table").data("statuses"),
      selector: ".js-prepress-extra-copies-table",
      roleType: "prepress",
      beforeRender: this.updateFilter,
    });
    list.render();
  }

  updateFilter({ sortScope, sortKey }) {
    if ($("#current-prepress-filter")) {
      $("#current-prepress-filter").text($(`${sortScope} li[data-title="${sortKey}"]`).data("name"));
    }
    $(`${sortScope} li[data-title="${sortKey}"]`).children(".text-right").children().removeClass("d-none");
  }

  show() {
    if (this.params.assignmentNotice) {
      new N2Styles.toast(`FYI this order is already assigned to ${this.params.assignedTo}`, { persistent: true });
    }
    if ($('.js-prepress-submit').length) {
      this.bindPrepressSubmit();
    }
  }

  bindPrepressSubmit() {
    N2.bindHandler('click', '.js-prepress-submit', (evt) => {
      evt.preventDefault();
      new N2StylesModal('.js-submit-prepress-modal');
    });
  }
}
